import Vue from 'vue'
import App from './App.vue'
// 全局引入 Reset-css
import 'reset-css'
// 引入样式
import 'vue-easytable/libs/themes-base/index.css'
// 导入 table 和 分页组件
Vue.config.productionTip = false




// 4. 创建和挂载根实例。
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能

new Vue({
  render: h => h(App)
}).$mount('#app')
